import { FC } from "react";

export type HoldoutStatus = "locked" | "applied" | "pending" | "off";

/** Where a holdout tier stands (MPN-2077). Locked is applied and published: the people
 *  are drawn and the channel is live, so a change now would re-draw a running measurement. */
const HoldoutBadge: FC<{ status: HoldoutStatus }> = ({ status }) => {
  switch (status) {
    case "locked":
      return (
        <span className="holdout-badge holdout-badge--locked">
          <i className="bi bi-lock-fill" aria-hidden="true" /> Applied · published · locked
        </span>
      );
    case "applied":
      return <span className="holdout-badge holdout-badge--applied">Applied</span>;
    case "pending":
      return <span className="holdout-badge">Not yet applied</span>;
    case "off":
      return <span className="holdout-badge">Off</span>;
  }
};

export default HoldoutBadge;
